/* eslint-disable implicit-arrow-linebreak */
import store from "@/store";
import normalizeSpaceElements from "@/@core/utils/element-utils";

export default async function ElementsListWidgetsFactory() {
  const rawElements = store.getters.currentCollective?.elements;
  const elements = normalizeSpaceElements(rawElements);
  if (!elements || Object.keys(elements).length === 0) {
    return {};
  }
  const arrayElements = Object.values(elements);

  const elementsByType = {};

   arrayElements.map((element) => {

    if(element.isVisible){

      elementsByType[element.key] = {
        key: element.key,
      loadComponent: () =>
        import("@/views/apps/elements/widgets/ElementsListWidget.vue"),
      props: { element }
      };

    }

  });

  return elementsByType;
}
